import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';

interface ResponsiveColumnsSignature {
  Args: {
    Named: {
      onChange: (columns: number) => void;
      breakpoints?: [number, number][];
    };
  };
}

export default class ResponsiveColumnsModifier extends Modifier<ResponsiveColumnsSignature> {
  #observer?: ResizeObserver;

  modify(
    element: Element,
    _: [],
    {
      onChange,
      breakpoints = [[1024, 3]],
    }: ResponsiveColumnsSignature['Args']['Named']
  ) {
    this.#observer?.disconnect();

    const compute = () => {
      const w = element.clientWidth;
      for (const [minW, cols] of [...breakpoints].sort((a, b) => b[0] - a[0])) {
        if (w >= minW) return cols;
      }
      return 2;
    };

    this.#observer = new ResizeObserver(() => onChange(compute()));
    this.#observer.observe(element);
    // Defer the initial call to avoid mutating tracked state during render
    // (the template already consumed numColumns via columnedSources).
    queueMicrotask(() => onChange(compute()));

    registerDestructor(this, () => this.#observer?.disconnect());
  }
}
